import { render, staticRenderFns } from "./Allergene.vue?vue&type=template&id=21a5a13c&scoped=true"
import script from "./Allergene.vue?vue&type=script&lang=js"
export * from "./Allergene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a5a13c",
  null
  
)

export default component.exports